import React from 'react';
import {
  Container, Typography, Box, Button,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/tours-module/ToursLandingViewV2/components/OffRoadPromoSection/OffRoadPromoSection.styles';
import { Typography700, Video } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import { REFS } from 'views/rebranded-module/common/utils/constants';

const OffRoadPromoSection = () => {
  const content = useContent('ToursLandingPage');
  const tourLandingRef = REFS.MOTORCYCLE_TOUR_LANGING;

  return (
    <StyledBox>
      <Box className="OPSOverlay" />
      <Video
        className="ORSVideo"
        videoSrc={content.offroadVideo.url}
        fallbackImg={{
          src: content.offroadVideoFallbackImage.url,
          alt: content.offroadVideoFallbackImage.alt,
          width: '100%',
          height: '100%',
        }}
      />

      <Container maxWidth="xxl" className="TLConatiner">
        <Box className="OPSContent">
          <Typography700 variant="h3" component="h3">
            {content.offroadHeader}
          </Typography700>
          <Typography color="text.secondary" variant="body2">
            {content.offroadSubheader}
          </Typography>
          <Button
            variant="contained"
            size="large"
            component={NavigatorLink}
            href={PATHS.guidedOffroadTour.index({
              ref: tourLandingRef,
            })}>
            {content.offroadButtonText}
          </Button>
        </Box>
      </Container>
    </StyledBox>
  );
};
export { OffRoadPromoSection };
